import { useMemo } from 'react';

import { getCachedResource } from 'apps/web_forms/utils/resourcesUtils';
import useResourceVersion from 'apps/web_forms/hooks/useResourceVersion';
import useGlobalSelector from 'apps/web_forms/hooks/useGlobalSelector';

/**
 * @typedef {Object} ResourceDataEtc
 * @property {Object} resourceData
 * @property {boolean} isLoading
 * @property {string | number} resourceVersion
 * @property {string} qualifiedResourceId
 */

/**
 * @param {string} resourceIdentifier
 * @returns {ResourceDataEtc}
 */
const useResourceData = (resourceIdentifier) => {
  const { resourceLoadCounter } = useGlobalSelector();
  const { resourceVersion, qualifiedResourceId } =
    useResourceVersion(resourceIdentifier);

  const isLoading = useMemo(() => {
    return qualifiedResourceId
      ? !getCachedResource(qualifiedResourceId)
      : false;
  }, [resourceLoadCounter, qualifiedResourceId]);

  const resourceData = useMemo(
    () =>
      qualifiedResourceId ? getCachedResource(qualifiedResourceId) : undefined,
    [resourceLoadCounter, qualifiedResourceId]
  );

  return {
    resourceData,
    isLoading,
    resourceVersion,
    qualifiedResourceId,
  };
};

export { useResourceData };
export default useResourceData;
